// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerHeading {
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
  padding: 15px 35px 25px 35px;
  border-bottom: 1px solid #979ea4;
  background-color: #fff;
}

.upperHome {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #77797b;
  margin-bottom: 10px;
}

.uh-simple {
  padding: 22px 0 !important;
}

.buttonsReturn {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-right: 70px;
}

.titleHome {
  font-size: 16px;
  font-weight: 700;
}

.containerPartnumber {
  display: flex;
  flex-direction: row;
  gap: 35px;
}

.blockNumber {
  padding: 13px 0;
  width: 90%;
  position: relative;
}

.positionHarm {
  position: absolute;
  right: -40px;
  display: flex;
  justify-content: space-around;
  width: 100px;
}

.positionT {
  cursor: pointer;
  position: relative;
}

.columnOne {
  border-right: 1px solid #77797b;
  width: 50.5%;
}

.columnTwo {
  width: 47.5%;
}

.titleBlock {
  color: #000;
  padding-right: 5px;
  font-size: 16px;
}

.statusTitle {
  font-weight: 500;
  padding-right: 10px;
  font-size: 15px;
}

.containerStatus {
  display: flex;
  padding: 10px 0px 20px 0px;
  position: relative;
}

.cs-simple{
  padding: 10px 0px 0px 0px ;
}

.detalsLaudo {
  display: flex;
  flex-direction: column;
  font-size: 15px;
}

.detalsIA {
  display: flex;
  flex-direction: column;
  font-size: 15px;
  margin-top: -30px;
}

.iconsContainer {
  width: auto;
  justify-content: space-between;
  display: flex;
  position: absolute;
  right: 120px;
  top: 22px;
  align-items: center;
  gap: 16px;
}

.iconsContainer img {
  margin-right: 35px;
  height: 18px;
  cursor: pointer;
}

.iconsContainer div.no-active,
.iconsContainer div.active {
  cursor: pointer;
}

.iconsContainer img:last-child {
  margin-right: 0px;
}

.iconsContainer img.iconMessage {
  height: 13px;
  position: absolute;
  left: -18px;
  top: -7px;
}

.modal .containerMaterial {
  display: flex;
  padding: 0px;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0px;
}

.modal .containerMaterial .column-1 {
  width: 100%;
}

.modal .containerMaterial .column-1 .bodyComments,
.modal .containerDownloadImages .bodyComments {
  width: auto;
}

.modalCorporate.filesModal .modal {
  width: auto;
  max-width: none;
}

.modalCorporate.filesModal .containerDescription {
  width: 100%;
  min-width: 0;
}

.modalCorporate.filesModal .containerDownloadImages .bodyComments {
  border: 0;
  width: 100%;
  display: contents;
}

.modalCorporate.filesModal .containerDownloadImages .bodyComments span {
  font-weight: bold;
  margin-right: 45px;
}

.modal .containerDescription {
  width: auto;
  min-width: 400px;
}

.modal .containerMaterial .bodyComments div {
  width: 100%;
}

.modal .containerMaterial .bodyComments div.textMessage,
.modal .containerMaterial .bodyComments div.textData {
  width: 95%;
}

.na-text {
  position: absolute;
  top: 15px;
  left: 215px;
}

.iconsContainer .containerDowload {
  display: flex;
  flex-direction: column;
  min-height: 40px;
  position: absolute;
  top: 26px;
  left: 0px;
  margin-bottom: 0px;
  gap: 0;
  z-index: 999;
}

.iconsContainer .containerDowload .buttonDownload {
  width: 138px;
  font-size: 15px;
  padding: 10px 8px;
  color: #000 !important;
  background-color: #eff1f2;
}

.iconsContainer .containerDowload .buttonDownload:hover {
  color: #fff !important;
  background-color: #007bc0;
}

.iconsContainer .active {
  background-color: #eff1f2;
  width: 25px;
  height: 20px;
  padding: 4px 4px;
  display: flex;
  text-align: center;
  position: relative;
  justify-content: center;
}

.iconsContainer .no-active {
  height: 20px;
}

.iconsContainer .active img, 
.iconsContainer .no-active img {
  height: 26px;
  margin-top: -3px;
  margin-left: -2px;
}

.aprovador .buttonsReturn {
  margin-right: 0;
}

.iconButton {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.iconCommentBtn{
  padding: 0px;
  display: flex;
  align-items: center;
}

.explainabilityLoadingOverlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  cursor: wait;
}

.explainabilityLoadingContent {
  display: flex;
  min-width: 280px;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 30px 36px;
  border-radius: 8px;
  background: #fff;
  color: #003e64;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.24);
}

.iconButton:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/heading/heading.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".containerHeading {\n  display: flex;\n  position: relative;\n  width: 100%;\n  flex-direction: column;\n  padding: 15px 35px 25px 35px;\n  border-bottom: 1px solid #979ea4;\n  background-color: #fff;\n}\n\n.upperHome {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #77797b;\n  margin-bottom: 10px;\n}\n\n.uh-simple {\n  padding: 22px 0 !important;\n}\n\n.buttonsReturn {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  margin-right: 70px;\n}\n\n.titleHome {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.containerPartnumber {\n  display: flex;\n  flex-direction: row;\n  gap: 35px;\n}\n\n.blockNumber {\n  padding: 13px 0;\n  width: 90%;\n  position: relative;\n}\n\n.positionHarm {\n  position: absolute;\n  right: -40px;\n  display: flex;\n  justify-content: space-around;\n  width: 100px;\n}\n\n.positionT {\n  cursor: pointer;\n  position: relative;\n}\n\n.columnOne {\n  border-right: 1px solid #77797b;\n  width: 50.5%;\n}\n\n.columnTwo {\n  width: 47.5%;\n}\n\n.titleBlock {\n  color: #000;\n  padding-right: 5px;\n  font-size: 16px;\n}\n\n.statusTitle {\n  font-weight: 500;\n  padding-right: 10px;\n  font-size: 15px;\n}\n\n.containerStatus {\n  display: flex;\n  padding: 10px 0px 20px 0px;\n  position: relative;\n}\n\n.cs-simple{\n  padding: 10px 0px 0px 0px ;\n}\n\n.detalsLaudo {\n  display: flex;\n  flex-direction: column;\n  font-size: 15px;\n}\n\n.detalsIA {\n  display: flex;\n  flex-direction: column;\n  font-size: 15px;\n  margin-top: -30px;\n}\n\n.iconsContainer {\n  width: auto;\n  justify-content: space-between;\n  display: flex;\n  position: absolute;\n  right: 120px;\n  top: 22px;\n  align-items: center;\n  gap: 16px;\n}\n\n.iconsContainer img {\n  margin-right: 35px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.iconsContainer div.no-active,\n.iconsContainer div.active {\n  cursor: pointer;\n}\n\n.iconsContainer img:last-child {\n  margin-right: 0px;\n}\n\n.iconsContainer img.iconMessage {\n  height: 13px;\n  position: absolute;\n  left: -18px;\n  top: -7px;\n}\n\n.modal .containerMaterial {\n  display: flex;\n  padding: 0px;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 0px;\n}\n\n.modal .containerMaterial .column-1 {\n  width: 100%;\n}\n\n.modal .containerMaterial .column-1 .bodyComments,\n.modal .containerDownloadImages .bodyComments {\n  width: auto;\n}\n\n.modalCorporate.filesModal .modal {\n  width: auto;\n  max-width: none;\n}\n\n.modalCorporate.filesModal .containerDescription {\n  width: 100%;\n  min-width: 0;\n}\n\n.modalCorporate.filesModal .containerDownloadImages .bodyComments {\n  border: 0;\n  width: 100%;\n  display: contents;\n}\n\n.modalCorporate.filesModal .containerDownloadImages .bodyComments span {\n  font-weight: bold;\n  margin-right: 45px;\n}\n\n.modal .containerDescription {\n  width: auto;\n  min-width: 400px;\n}\n\n.modal .containerMaterial .bodyComments div {\n  width: 100%;\n}\n\n.modal .containerMaterial .bodyComments div.textMessage,\n.modal .containerMaterial .bodyComments div.textData {\n  width: 95%;\n}\n\n.na-text {\n  position: absolute;\n  top: 15px;\n  left: 215px;\n}\n\n.iconsContainer .containerDowload {\n  display: flex;\n  flex-direction: column;\n  min-height: 40px;\n  position: absolute;\n  top: 26px;\n  left: 0px;\n  margin-bottom: 0px;\n  gap: 0;\n  z-index: 999;\n}\n\n.iconsContainer .containerDowload .buttonDownload {\n  width: 138px;\n  font-size: 15px;\n  padding: 10px 8px;\n  color: #000 !important;\n  background-color: #eff1f2;\n}\n\n.iconsContainer .containerDowload .buttonDownload:hover {\n  color: #fff !important;\n  background-color: #007bc0;\n}\n\n.iconsContainer .active {\n  background-color: #eff1f2;\n  width: 25px;\n  height: 20px;\n  padding: 4px 4px;\n  display: flex;\n  text-align: center;\n  position: relative;\n  justify-content: center;\n}\n\n.iconsContainer .no-active {\n  height: 20px;\n}\n\n.iconsContainer .active img, \n.iconsContainer .no-active img {\n  height: 26px;\n  margin-top: -3px;\n  margin-left: -2px;\n}\n\n.aprovador .buttonsReturn {\n  margin-right: 0;\n}\n\n.iconButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.iconCommentBtn{\n  padding: 0px;\n  display: flex;\n  align-items: center;\n}\n\n.explainabilityLoadingOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.45);\n  cursor: wait;\n}\n\n.explainabilityLoadingContent {\n  display: flex;\n  min-width: 280px;\n  flex-direction: column;\n  align-items: center;\n  gap: 18px;\n  padding: 30px 36px;\n  border-radius: 8px;\n  background: #fff;\n  color: #003e64;\n  font-size: 16px;\n  font-weight: 600;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.24);\n}\n\n.iconButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
